"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _helpers = require("../../helpers");

var _themeOptions = require("../../helpers/theme-options");

var _useStyles = require("../../hooks/useStyles");

var _styled = require("../../styled");

var _const = require("../../const");

var _carouselUi = _interopRequireDefault(require("../carousel/carousel-ui"));

var _useMedia = require("../../hooks/use-media");

var _linkUi = _interopRequireDefault(require("../link/link-ui"));

var _const2 = require("../link/const");

var _headerTitles = require("../header-titles");

var _lazyLoadImage = require("../lazy-load-image");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _style = _interopRequireDefault(require("./style"));

var _types = require("./types");

var _variableColumn = require("./variable-column.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VariableColumn = function VariableColumn(_ref) {
  var id = _ref.id,
      headline1 = _ref.headline1,
      headline2 = _ref.headline2,
      description = _ref.description,
      $textAlign = _ref.textAlign,
      _ref$columnContents = _ref.columnContents,
      data = _ref$columnContents === void 0 ? [] : _ref$columnContents,
      _ref$theme = _ref.theme,
      $theme = _ref$theme === void 0 ? _themeOptions.ThemeVariants.WHITE : _ref$theme,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? 2 : _ref$columns,
      _ref$mobileLayout = _ref.mobileLayout,
      mobileLayout = _ref$mobileLayout === void 0 ? _types.KeyValueMobLayout.GRID : _ref$mobileLayout,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? '1:1' : _ref$aspectRatio,
      _ref$gridType = _ref.gridType,
      gridType = _ref$gridType === void 0 ? _types.KeyValueGridType.INSET : _ref$gridType,
      _ref$removeTopPadding = _ref.removeTopPadding,
      removeTopPadding = _ref$removeTopPadding === void 0 ? false : _ref$removeTopPadding,
      _ref$removeBottomPadd = _ref.removeBottomPadding,
      removeBottomPadding = _ref$removeBottomPadd === void 0 ? false : _ref$removeBottomPadd;
  var styles = (0, _useStyles.useStyles)('a', _style.default);
  var theme = {
    $textAlign: $textAlign,
    $theme: $theme,
    $columns: columns,
    $styles: styles,
    $aspectRatio: aspectRatio,
    $gridType: columns > 3 ? _types.KeyValueGridType.INSET : gridType,
    $mobileLayout: mobileLayout,
    $hasButtons: !!buttons.length
  };
  var isCarouselMobileLayout = mobileLayout === _types.KeyValueMobLayout.CAROUSEL;
  var isScrollMobileLayout = mobileLayout === _types.KeyValueMobLayout.SCROLL;
  var isStackMobileLayout = mobileLayout === _types.KeyValueMobLayout.STACK;
  var _themeStrategy$$theme = _themeOptions.themeStrategy[$theme],
      headline1Color = _themeStrategy$$theme.headline1Color,
      headline2Color = _themeStrategy$$theme.headline2Color,
      type = _themeStrategy$$theme.type,
      size = _themeStrategy$$theme.size;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isHalfTheme = size === _themeOptions.ThemeSize.HALF || size === _themeOptions.ThemeSize.CROPPED;
  var btnColor = isHalfTheme ? 'gray800' : (0, _helpers.getButtonColorByTheme)(isDarkTheme);
  var isMobColumnView = data.length % 2 === 0;
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var isTablet = (0, _useMedia.useMedia)(_const.Breakpoints.TABLET);
  var responsive = [{
    adaptiveHeight: true,
    breakpoint: Number(_uiKit.GridBreakpointsMax.lg),
    settings: {
      slidesToShow: 2,
      variableWidth: isScrollMobileLayout,
      arrows: isCarouselMobileLayout,
      dots: false
    }
  }, {
    breakpoint: Number(_uiKit.GridBreakpointsMax.md),
    settings: {
      slidesToShow: 1,
      variableWidth: isScrollMobileLayout,
      arrows: isCarouselMobileLayout,
      dots: false
    }
  }];
  var VariableColumnItems = data.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_variableColumn.Item, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
      fullWidth: true
    }, /*#__PURE__*/_react.default.createElement(_variableColumn.ImageWrapper, null, item.imageLink ? /*#__PURE__*/_react.default.createElement(_linkUi.default, {
      link: item.imageLink,
      target: (0, _const2.linkTarget)(item.imageLink)
    }, /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
      src: item.image,
      placeholderSrc: item.image,
      alt: item.altText,
      skipLazy: (isMobile || isTablet) && (isCarouselMobileLayout || isScrollMobileLayout)
    })) : /*#__PURE__*/_react.default.createElement(_lazyLoadImage.LazyLoadImage, {
      src: item.image,
      placeholderSrc: item.image,
      alt: item.altText,
      skipLazy: (isMobile || isTablet) && (isCarouselMobileLayout || isScrollMobileLayout)
    })), item.headline && (columns > 3 ? /*#__PURE__*/_react.default.createElement(_variableColumn.HeadlineH5, null, item.headline) : /*#__PURE__*/_react.default.createElement(_variableColumn.HeadlineH4, null, item.headline)), item.columnText && /*#__PURE__*/_react.default.createElement(_variableColumn.Line2, {
      dangerouslySetInnerHTML: {
        __html: item.columnText
      }
    })), item.cta && !!item.cta.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
      color: btnColor,
      buttons: item.cta,
      isButtonFullWidth: true,
      alignCenter: $textAlign === _const.TextAlignment.CENTER,
      mt: 30
    }));
  });
  var sliderContainerHorizontalPadding = {
    xs: isScrollMobileLayout ? 0 : 15,
    lg: 15
  };
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_variableColumn.Container, {
    removeBottomPadding: removeBottomPadding,
    removeTopPadding: removeTopPadding,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_VARIABLE_COLUMN,
    id: id
  }, (headline1 || headline2 || description) && /*#__PURE__*/_react.default.createElement(_variableColumn.HeaderWrapStyled, {
    pl: 20,
    pr: 20,
    pb: {
      xs: 30,
      md: 45
    }
  }, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: headline1Color,
    headline2Color: headline2Color,
    descriptionAlign: $textAlign
  })), /*#__PURE__*/_react.default.createElement(_variableColumn.GridBox, null, /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    pl: sliderContainerHorizontalPadding,
    pr: sliderContainerHorizontalPadding
  }, /*#__PURE__*/_react.default.createElement(_variableColumn.Row, {
    isMobColumnView: isMobColumnView,
    hideMd: isCarouselMobileLayout || isScrollMobileLayout
  }, VariableColumnItems), !isStackMobileLayout && /*#__PURE__*/_react.default.createElement(_styled.ShowMd, null, isCarouselMobileLayout && /*#__PURE__*/_react.default.createElement(_variableColumn.CarouselWrap, null, /*#__PURE__*/_react.default.createElement(_carouselUi.default, {
    settings: {
      infinite: true,
      responsive: responsive,
      lazyLoad: 'progressive'
    },
    inverse: isDarkTheme,
    transparent: true
  }, VariableColumnItems)), isScrollMobileLayout && /*#__PURE__*/_react.default.createElement(_variableColumn.ScrollWrap, null, /*#__PURE__*/_react.default.createElement(_carouselUi.default, {
    settings: {
      arrows: false,
      infinite: false,
      lazyLoad: 'progressive',
      responsive: responsive
    },
    inverse: isDarkTheme,
    transparent: true
  }, VariableColumnItems))))), !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    mt: {
      xs: isCarouselMobileLayout || isScrollMobileLayout ? 30 : 15,
      lg: 15
    },
    color: btnColor
  })));
};

var _default = VariableColumn;
exports.default = _default;